(() => {
  'use strict';
  for (const host of document.querySelectorAll('[data-nimall-related-host]')) {
    if (host.dataset.relatedInitialized) continue;
    host.dataset.relatedInitialized = 'true';
    const id = host.dataset.productId, key = host.dataset.contextKey, currency = host.dataset.quoteCurrency;
    if (!/^[1-9]\d*$/.test(id || '') || !key || !/^[A-Z]{3}$/.test(currency || '')) continue;
    let url;
    try { url = new URL(host.dataset.relatedUrl, location.origin); } catch { continue; }
    if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?recommendations\/products$/.test(url.pathname)
      || url.searchParams.get('product_id') !== id || url.searchParams.get('section_id') !== host.dataset.relatedSection
      || url.searchParams.get('limit') !== '10' || url.searchParams.get('intent') !== 'related'
      || [...url.searchParams.keys()].some(k => !['product_id', 'section_id', 'limit', 'intent'].includes(k))) continue;
    let revision = 0, controller;
    const clear = () => { revision++; controller?.abort(); host.replaceChildren(); };
    async function refresh() {
      clear();
      if (document.hidden) return;
      const current = revision;
      controller = new AbortController();
      const signal = controller.signal, timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal });
        if (!response.ok || response.url && new URL(response.url).origin !== location.origin) return;
        const html = await response.text();
        if (html.length > 1_000_000) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const candidates = [...parsed.querySelectorAll('[data-nimall-related-host]')];
        if (candidates.length !== 1) return;
        const source = candidates[0];
        if (source.dataset.productId !== id || source.dataset.contextKey !== key || source.dataset.quoteCurrency !== currency
          || source.dataset.relatedSection !== host.dataset.relatedSection) return;
        const shelves = source.querySelectorAll('[data-nimall-related="governed-context-v1"]');
        if (shelves.length !== 1 || shelves[0].dataset.contextProductId !== id) return;
        const shelf = shelves[0], cards = [...shelf.querySelectorAll('.nimall-related-pick')], seen = new Set([id]);
        if (!cards.length || cards.length > 7 || Number(shelf.dataset.relatedCount) !== cards.length) return;
        for (const card of cards) {
          const productId = card.dataset.relatedProductId, variant = card.dataset.quoteVariantId;
          if (!/^[1-9]\d*$/.test(productId || '') || seen.has(productId) || card.dataset.relatedKey !== key
            || card.dataset.quoteCurrency !== currency || !/^[1-9]\d*$/.test(variant || '')
            || !Number.isSafeInteger(Number(card.dataset.quotePriceMinor)) || Number(card.dataset.quotePriceMinor) <= 0) return;
          const input = card.querySelector('.y01-product-card input[name="id"]');
          if (!input || input.value !== variant || !card.querySelector('.product-item')) return;
          const directInputs = [...card.querySelectorAll('.nimall-related-pick__web form.variants input[name="id"]')];
          if (directInputs.some(n => n.value !== variant)) return;
          seen.add(productId);
        }
        if (current !== revision || signal.aborted || document.hidden) return;
        shelf.querySelectorAll('script:not([type="application/json"])').forEach(n => n.remove());
        host.replaceChildren(shelf);
        host.dispatchEvent(new CustomEvent('nimall:related-rendered', { bubbles: true }));
      } catch { /* Empty is safer than a stale or unverifiable quote. */ }
      finally { clearTimeout(timeout); }
    }
    if (!host.querySelector('[data-nimall-related]')) void refresh();
    document.addEventListener('cart:updated', () => { void refresh(); });
    document.addEventListener('nimall:cart-updated', () => { void refresh(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) clear(); else void refresh(); });
    window.addEventListener('pageshow', event => { if (event.persisted) void refresh(); });
  }
})();
